import { Outlet } from 'react-router'
import { PageLayout, StatePanel } from '@/components/common'
import { useOrganization } from '@/contexts/OrganizationContext'

function IGamingLayout() {
  const { hasProductAccess } = useOrganization()

  if (!hasProductAccess('igaming_search', 'view')) {
    return (
      <PageLayout>
        <StatePanel state="restricted" title="iGaming is not enabled" description="This organization does not have access to iGaming Search." />
      </PageLayout>
    )
  }

  return <Outlet />
}

export default IGamingLayout
